import login from './login';

export default {
  language: 'uz-UZ',
  country: 'uz',
  name: "O'zbek",
  embeddedLocale: login,
};
